import React, { useEffect } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { useNavigate } from 'react-router-dom';
import { useLogin } from '../../hooks/useLogin';
import InputOtp from '../../components/InputOtp';
import { OtpReason } from '../../repositories/AuthRepository';

const OtpAuth: React.FC = () => {
  const { loginType, email, npub, otpId } = useLogin();
  const {setCredentialsOnLogin} = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if(loginType === null || otpId === '' || otpId === undefined || otpId === null) {
      navigate('/login');
    }
  }, [loginType, navigate, otpId]);

  if(loginType === null)
    return null;

  return (
    <InputOtp 
      loginType={loginType} 
      email={email ?? ''} 
      npub={npub ?? ''} 
      otpId={otpId} 
      onVerify={async (credentials, pleb) => {
        await setCredentialsOnLogin(credentials, pleb);
        navigate('/home/chat');
      }} 
      otpReason={OtpReason.LOGIN}
    />
  );
};

export default OtpAuth;
